import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang, useCart } from "../context";
import { t, COLLECTIONS } from "../content";
import { ShoppingBag, Menu, X } from "lucide-react";

export const Navbar = () => {
  const { lang, toggleLang } = useLang();
  const { cart } = useCart();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const count = cart.reduce((a, i) => a + i.quantity, 0);

  const links = [
    { to: "/", label: t.nav.home[lang] },
    { to: "/shop", label: t.nav.shop[lang] },
    { to: "/about", label: t.nav.about[lang] },
    { to: "/contact", label: t.nav.contact[lang] },
  ];

  return (
    <header className="sticky top-0 z-50 bg-[#F9F8F6]/80 backdrop-blur-xl border-b border-[#1A1A1A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="serif text-xl tracking-[0.18em] font-medium whitespace-nowrap">
          CLASS<span className="text-[#737373]">ONE</span> <span className="text-[0.7em] tracking-[0.3em] text-[#737373] align-middle">VINTAGE</span>
        </Link>

        <nav className="hidden md:flex items-center gap-9 text-[13px] tracking-wide uppercase">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={`co-link ${loc.pathname === l.to ? "opacity-100" : "opacity-70 hover:opacity-100"} transition-opacity`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <button onClick={toggleLang} data-testid="lang-toggle-btn"
            className="text-[12px] tracking-widest border border-[#1A1A1A]/20 rounded-sm px-2.5 py-1 hover:bg-[#1A1A1A] hover:text-[#F9F8F6] transition-colors">
            {lang === "fr" ? "EN" : "FR"}
          </button>
          <Link to="/cart" data-testid="cart-link" className="relative">
            <ShoppingBag size={20} strokeWidth={1.5} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-[#1A1A1A] text-[#F9F8F6] text-[10px] w-4 h-4 rounded-full flex items-center justify-center">{count}</span>
            )}
          </Link>
          <button className="md:hidden" data-testid="mobile-menu-btn" onClick={() => setOpen((o) => !o)}>
            {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#1A1A1A]/10 px-6 py-4 flex flex-col gap-4 bg-[#F9F8F6]">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="uppercase text-sm tracking-wide">{l.label}</Link>
          ))}
          <div className="pt-2 border-t border-[#1A1A1A]/10 text-xs uppercase tracking-widest text-[#737373]">{t.nav.collections[lang]}</div>
          {COLLECTIONS.map((c) => (
            <Link key={c.slug} to={`/shop?c=${c.slug}`} onClick={() => setOpen(false)} className="text-sm">{c[lang]}</Link>
          ))}
        </div>
      )}
    </header>
  );
};
